// File: src/English/Grade1/PhonicsMatchingGame.jsx

import React, { useState, useEffect } from "react";
import SpeakButton from "./SpeakButton";
import "./PhonicsMatchingGame.css";

export default function PhonicsMatchingGame({ onFinish }) {
  // Minimal example with 3 items:
  const [items] = useState([
    {
      matchId: "apple",
      word: "Apple",
      letter: "A",
      imgSrc: "/images/Phonics/Apple.png",
      alt: "Apple",
    },
    {
      matchId: "cat",
      word: "Cat",
      letter: "C",
      imgSrc: "/images/Phonics/Cat.png",
      alt: "Cat",
    },
    {
      matchId: "dog",
      word: "Dog",
      letter: "D",
      imgSrc: "/images/Phonics/Dog.png",
      alt: "Dog",
    },
  ]);

  // Track matches and dragging
  const [correctPairs, setCorrectPairs] = useState([]);
  const [draggedMatchId, setDraggedMatchId] = useState(null);

  // For finishing logic
  const [gameFinished, setGameFinished] = useState(false);
  const [score, setScore] = useState(0);

  // Check if user matched all items
  useEffect(() => {
    if (correctPairs.length === items.length) {
      setScore(correctPairs.length);
      setGameFinished(true);
    }
  }, [correctPairs, items.length]);

  // Drag handlers
  const handleDragStart = (matchId) => {
    setDraggedMatchId(matchId);
  };

  const handleDropOnImage = (imageMatchId) => {
    if (draggedMatchId === imageMatchId) {
      setCorrectPairs((prev) => [...prev, imageMatchId]);
    }
    setDraggedMatchId(null);
  };

  // If the game is finished, show a small “win” screen
  if (gameFinished) {
    return (
      <div className="matching-game-container">
        <h2 className="matching-game-title">Phonics Matching Game</h2>
        <p>Great job! You matched {score}/{items.length} correctly.</p>
        <button
          className="button1"
          onClick={() => onFinish && onFinish(score, items.length)}
        >
          Continue
        </button>
      </div>
    );
  }

  // Otherwise, normal matching UI
  return (
    <div className="matching-game-container">
      <h2 className="matching-game-title">Phonics Matching Game</h2>
      <p className="matching-game-instruction">
        Drag the correct word (on the left) onto the matching picture (on the right)!
      </p>

      <div className="matching-game-wrap">
        {/* Left side: words */}
        <div className="matching-col words-col">
          {items.map((item) => {
            const matched = correctPairs.includes(item.matchId);
            return (
              <div
                key={item.matchId}
                className="matching-word"
                draggable={!matched}
                onDragStart={() => handleDragStart(item.matchId)}
              >
                <strong>{item.letter}</strong> – {item.word}
                <SpeakButton text={item.word} />
              </div>
            );
          })}
        </div>

        {/* Right side: images */}
        <div className="matching-col images-col">
          {items.map((item) => {
            const matched = correctPairs.includes(item.matchId);
            return (
              <div
                key={item.matchId}
                className={`matching-img-slot ${matched ? "matched" : ""}`}
                onDragOver={(e) => e.preventDefault()}
                onDrop={() => handleDropOnImage(item.matchId)}
              >
                <img
                  src={item.imgSrc}
                  alt={item.alt}
                  className="matching-image"
                />
                {matched && <div className="correct-overlay">✓</div>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
